module.exports = __webpack_public_path__ + "static/media/work7.d71d4814.jpg";